import { call, put, takeLatest } from "redux-saga/effects";
import { nganhXetTuyenApi } from "../../../api/category/nganhXetTuyenApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eTsNganhXetTuyenActionIds } from "../../action-types/category/ITsNganhXetTuyenActions";
import { rootActions } from "../../actions/rootActions";

export function* tsNganhXetTuyenSaga(): any {
  yield takeLatest(eTsNganhXetTuyenActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(nganhXetTuyenApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.tsNganhXetTuyen.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.tsNganhXetTuyen.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
